import {
  INSPECTIFY_EMAIL,
  INSPECTIFY_EMAIL_LINK,
  INSPECTIFY_PHONE_NUMBER_FORMATTED,
  INSPECTIFY_PHONE_NUMBER_LINK,
} from '@inspectify/core';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import React from 'react';
import { CURRENT_YEAR } from '../../../utils';
import { Stack } from "@mui/material";

const ContractorDrawerFooter = () => (
  <Box
    sx={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      padding: 2,
      borderTop: '1px solid',
      borderTopColor: 'divider',
      backgroundColor: 'background.paper',
    }}
  >
    <Stack spacing={1}>
      <Typography variant="body2">
        Questions? Reach out to us!
      </Typography>
      <Box>
        <Typography variant="body2">
          Email: <Link
          href={INSPECTIFY_EMAIL_LINK}
          fontWeight="bold"
          underline="none"
          color="primary"
        >{INSPECTIFY_EMAIL}</Link>
        </Typography>
        <Typography variant="body2">
          Text our team at&nbsp;
          <Link
            href={INSPECTIFY_PHONE_NUMBER_LINK}
            fontWeight="bold"
            underline="none"
            color="primary"
          >{INSPECTIFY_PHONE_NUMBER_FORMATTED}</Link>
        </Typography>
      </Box>
      <Typography variant="body2">©{CURRENT_YEAR} Inspectify Inc.</Typography>
    </Stack>
  </Box>
);

export default ContractorDrawerFooter;
